// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__pcWBd","logo":"MainNavigation_logo__3mTft","active":"MainNavigation_active__oN3Ka","badge":"MainNavigation_badge__QYsXO"};